import React, { useState, useEffect } from 'react';
import Layout from 'components/Layout';
import i18n from 'i18n-js';
import Logs from 'components/Logs';
import Feature from 'components/Feature';
import Can from 'components/Can';
import Title from 'components/Title';
import OrgAbility from 'components/OrgAbility';
import { AlarmsWidget } from 'components/Alarms';
import { ReservationModal } from 'components/Modals';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Button, Container } from '@mui/material';
import { UserSettingsActions } from 'state/modules/userSettings';
import { Snapshots, Statistics, CalendarWidget } from 'components/Dashboard';

const DashboardPage = () => {
  const dispatch = useDispatch();
  const [openReservationModal, setOpenReservationModal] = useState(false);
  const guidingModalOpen = useSelector((state) => state.userSettings?.guidingModalOpen);

  const { core } = useSelector((state) => state.config?.settings || {});

  useEffect(() => {
    if (guidingModalOpen === 'INIT') {
      dispatch(UserSettingsActions.handleShowGuidingModal(true));
    }
  }, [guidingModalOpen, dispatch]);

  const handleOpenReservationModal = () => {
    setOpenReservationModal((prevState) => !prevState);
  };

  const createReservation = core?.reservation?.create;

  return (
    <Layout title="Dashboard">
      <Container sx={{ margin: 0, minWidth: '100%' }}>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid size={12}>
            <Grid
              container
              rowSpacing={1}
              direction="row"
              justifyContent="space-between"
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid>
                <Title dataCy="dashboard-title" title={i18n.t('dashboard.title')} />
              </Grid>
              {createReservation ? (
                <Feature name="reservation" is="enabled">
                  <Can I="create" a="reservation">
                    <Grid>
                      <Button
                        color="primary"
                        variant="contained"
                        data-cy="create-reservation-btn"
                        onClick={() => {
                          handleOpenReservationModal();
                        }}
                        style={{ textTransform: 'inherit' }}
                      >
                        {i18n.t('reservations.create_new_reservation')}
                      </Button>
                    </Grid>
                  </Can>
                </Feature>
              ) : null}
            </Grid>
          </Grid>
          <Can I="read" on="vehicle_group">
            <Grid size={12}>
              <Statistics type="reservations" />
            </Grid>
            <OrgAbility subject={['msServiceOrg', 'plainOrg']}>
              <Grid size={12}>
                <Snapshots type="reservations" />
              </Grid>
            </OrgAbility>
          </Can>
          <Grid size={12}>
            <CalendarWidget />
          </Grid>
          <Grid size={{ xs: 12, md: 8 }}>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Can I="read" on="conditional_instance">
                <Grid size={{ xs: 12, md: 6 }}>
                  <AlarmsWidget />
                </Grid>
              </Can>
            </Grid>
          </Grid>
          <Can I="read" on="event_log">
            <Grid size={{ xs: 12, md: 4 }}>
              <Logs secondary={false} height={439} />
            </Grid>
          </Can>
        </Grid>
      </Container>
      {openReservationModal && (
        <ReservationModal open={openReservationModal} handleClick={handleOpenReservationModal} />
      )}
    </Layout>
  );
};

export default DashboardPage;
